
angular.module('siter.io').factory 'Translit', ["$state", ($state) ->

  # Translit service

  transliterate =
    one: (text, engToRus) ->
      rus = 'щ   ш  ч  ц  ю  я  ё  ж  ъ  ы  э  а б в г д е з и й к л м н о п р с т у ф х ь'.split(RegExp(' +', 'g'))
      eng = 'shh sh ch cz yu ya yo zh sh y e a b v g d e z i j k l m n o p r s t u f x '.split(RegExp(' +', 'g'))
      x = undefined
      if typeof text != 'undefined'
        x = 0
        while x < rus.length
          text = text.split(if engToRus then eng[x] else rus[x]).join(if engToRus then rus[x] else eng[x])
          text = text.split(if engToRus then eng[x].toUpperCase() else rus[x].toUpperCase()).join(if engToRus then rus[x].toUpperCase() else eng[x].toUpperCase())
          x++
        return text.toLowerCase().replace(RegExp(' ', 'g'), '_').replace(/-/g, '_').replace(/[^a-z_A-ZА-Яа-я0-9\s]/g, '')
      return
    two: (text, engToRus) ->
      rus = 'щ   ш  ч  ц  ю  я  ё  ж  ъ  ы  э  а б в г д е з и й к л м н о п р с т у ф х ь'.split(RegExp(' +', 'g'))
      eng = 'shh sh ch cz yu ya yo zh sh y e a b v g d e z i j k l m n o p r s t u f x '.split(RegExp(' +', 'g'))
      x = undefined
      if typeof text != 'undefined'
        x = 0
        while x < rus.length
          text = text.split(if engToRus then eng[x] else rus[x]).join(if engToRus then rus[x] else eng[x])
          text = text.split(if engToRus then eng[x].toUpperCase() else rus[x].toUpperCase()).join(if engToRus then rus[x].toUpperCase() else eng[x].toUpperCase())
          x++
        return text.toLowerCase().replace(RegExp(' ', 'g'), '-').replace(/_/g, '_')
      return
    three: (text, engToRus) ->
      rus = 'щ   ш  ч  ц  ю  я  ё  ж  ъ  ы  э  а б в г д е з и й к л м н о п р с т у ф х ь'.split(RegExp(' +', 'g'))
      eng = 'shh sh ch cz yu ya yo zh sh y e a b v g d e z i j k l m n o p r s t u f x '.split(RegExp(' +', 'g'))
      x = undefined
      if typeof text != 'undefined'
        x = 0
        while x < rus.length
          text = text.split(if engToRus then eng[x] else rus[x]).join(if engToRus then rus[x] else eng[x])
          text = text.split(if engToRus then eng[x].toUpperCase() else rus[x].toUpperCase()).join(if engToRus then rus[x].toUpperCase() else eng[x].toUpperCase())
          x++
        return text.toLowerCase().replace(RegExp(' ', 'g'), '-').replace(/_/g, '-').replace(/[^a-z_A-ZА-Яа-я0-9\s]/g, '')
      return
  transliterate
]




// WEBPACK FOOTER //
// ./src/app/common/services/translit.service.coffee